import {
  PURGE, PAUSE, FLUSH, PERSIST,
} from 'redux-persist';

export const errorMiddleware = (store) => (next) => (action) => {
  if (action.type !== PURGE && action.type !== PAUSE && action.type !== FLUSH && action.type !== PERSIST) {
    const state = store.getState();

    if (!state.helpers || state.helpers.paused === true) {
      return Promise.resolve(true);
    }
  }

  return next(action);
};
